const sliderMain = document.querySelector('.slider__main');

const SLIDE_SPEED_FLIPPING_DELAY = 1000;
const SLIDE_SPEED_FLIPPING_DELAY_WITH_AUTO_PLAY = 2200;

const defaultSliderOptions = {
  watchOverflow: true,
  observer: true,
  resizeObserver: true,
  speed: SLIDE_SPEED_FLIPPING_DELAY,
  navigation: {
    nextEl: '.slider__main-next',
    prevEl: '.slider__main-prev',
    enabled: false
  }
};

const initSlider = (elem) => {
  if (!elem) return;

  const countsElements = elem.querySelectorAll('.slider__main-item').length;
  const sliderOptions = {...defaultSliderOptions};

  if (countsElements > 1) {
    sliderOptions.effect = "fade";
    sliderOptions.fadeEffect = {
      crossFade: true
    };
    sliderOptions.loop = true;
    sliderOptions.navigation.enabled = true;
  }

  if (elem.hasAttribute('data-autoplay')) {
    sliderOptions.autoplay = {
      delay: SLIDE_SPEED_FLIPPING_DELAY_WITH_AUTO_PLAY,
      disableOnInteraction: false
    };
  }

  const swiper = new Swiper(elem, sliderOptions);
};

if (sliderMain) {
  initSlider(sliderMain);
}
